import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styles: [
  ]
})
export class PopupComponent implements OnInit {
  webPopup: any = {}
  mobilePopup: any = {}
  constructor(
    private dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.data.images.forEach(
      (x)=>{
        if(x.platform == 'web_popup')
        {this.webPopup = x}
        if(x.platform == 'mobile_popup')
        {this.mobilePopup = x}
      })
  }
  closeDialog(){
    this.dialogRef.close()
  }
}
